import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { 
    NavController
} from '@ionic/angular/standalone';

import { MarvColor, MarvColorPrimary } from '@marv/types';
import { ApiService } from '@app/services';

@Component({
    selector: 'marv-link',
    templateUrl: './link.component.html',
    styleUrls: ['./link.component.scss'],
    imports: []
})
export class MarvLinkComponent  implements OnInit {
    
    @Input({alias : 'route', required : false}) route: string;  
    @Input({alias : 'params', required : false}) params: any;  
    @Input({alias : 'url', required : false}) url: string;  
    @Input({alias : 'openInNewTab', required : false}) openInNewTab: boolean = false;  
    @Input({alias : 'color', required : false}) colorButton: MarvColor = MarvColorPrimary;

    constructor(
        private router: Router,
        private navController: NavController,
        private apiService: ApiService
    ) { }

    ngOnInit() {}

    openLink() {
        
        if(this.route){
            if(!this.openInNewTab){                
                this.navController.navigateRoot(this.route, {queryParams: this.params});
            }
            else{
                let pageUrl = this.router.serializeUrl(this.router.createUrlTree([this.route], { queryParams: this.params }));
                window.open(pageUrl, '_blank');
            }                    
        }
        else if(this.url){
            let pageUrl = this.url + (this.params ? '?' + this.apiService.toQueryParams(this.params): '');
            window.open(pageUrl, (this.openInNewTab ? '_blank' : '_self'));
        }
        
    }
    
}
